import { render, staticRenderFns } from "./Spectators.vue?vue&type=template&id=be3b4bc2"
import script from "./Spectators.vue?vue&type=script&lang=js"
export * from "./Spectators.vue?vue&type=script&lang=js"
import style0 from "./Spectators.vue?vue&type=style&index=0&id=be3b4bc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports